import React, { Component } from "react";
import "./App.css";
import routes from "./routes";
import withRouter from "./components/withRouter";
import { Route, Routes, Navigate } from "react-router-dom";
import InverluxApps from "./apps/InverluxApps";

export const shouldRenderAppsSite = (hostname, nodeEnv, siteOverride) =>
  hostname === "apps.inverlux.com" ||
  (nodeEnv === "development" && siteOverride === "apps");

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    if (
      shouldRenderAppsSite(
        window.location.hostname,
        process.env.NODE_ENV,
        process.env.REACT_APP_INVERLUX_SITE
      )
    ) {
      return <InverluxApps />;
    }

    return (
      <React.Fragment>
        <Routes>
          {routes.map((route, idx) => (
            <Route path={route.path} element={route.component} key={idx} />
          ))}
          {/* Redirect any other paths to the index page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
